import { createRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "@/hooks/useSafeTranslation";
import { toSafeReactNode } from "@/lib/utils";
import { rootRoute } from "./__root";

function LawfulUsePage() {
  const { t } = useTranslation("common");

  return (
    <div className="min-h-screen bg-bg">
      <div className="mx-auto max-w-2xl px-6 py-12 space-y-8">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-text-muted hover:text-accent transition-colors">
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
          {toSafeReactNode(t("lawfulUsePage.back"))}
        </Link>

        <div>
          <h1 className="text-3xl font-bold tracking-tight text-text">{toSafeReactNode(t("lawfulUsePage.title"))}</h1>
          <p className="mt-2 text-sm text-text-muted">{toSafeReactNode(t("lawfulUsePage.subtitle"))}</p>
        </div>

        <div className="space-y-6">
          <section className="rounded-xl border border-border bg-surface p-6 space-y-3">
            <h2 className="text-base font-semibold text-text">{toSafeReactNode(t("lawfulUsePage.section1Title"))}</h2>
            <p className="text-sm text-text-muted leading-relaxed">
              {toSafeReactNode(t("lawfulUsePage.section1Content"))}
            </p>
          </section>

          <section className="rounded-xl border border-border bg-surface p-6 space-y-3">
            <h2 className="text-base font-semibold text-text">{toSafeReactNode(t("lawfulUsePage.section2Title"))}</h2>
            <p className="text-sm text-text-muted leading-relaxed">
              {toSafeReactNode(t("lawfulUsePage.section2Content"))}
            </p>
          </section>
        </div>

        <footer className="border-t border-border pt-6 text-center text-xs text-text-muted space-x-3">
          <Link to="/privacy" className="hover:text-text transition-colors">{toSafeReactNode(t("footer.privacy"))}</Link>
          <span className="text-border">·</span>
          <Link to="/terms" className="hover:text-text transition-colors">{toSafeReactNode(t("footer.terms"))}</Link>
          <span className="text-border">·</span>
          <Link to="/lawful-use" className="hover:text-text transition-colors">{toSafeReactNode(t("footer.lawfulUse"))}</Link>
          <span className="text-border">·</span>
          <Link to="/pricing" className="hover:text-text transition-colors">{toSafeReactNode(t("footer.pricing"))}</Link>
        </footer>
      </div>
    </div>
  );
}

export const lawfulUseRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/lawful-use",
  component: LawfulUsePage,
});
